module.exports = {"maxRoutes":{"2":"2","3":"3","4":"4","5":"5"},"routeNumber":{"1":"1","2":"2","3":"3","4":"4","5":"5","All":"0"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/_modules/Approvals/Approval-rule/route-values.json
// module id = 1SGE
// module chunks = 12